export enum Widget {
  ANNOTATIONS = "annotations",
  CHAT = "chat",
  DIRECTORY = "directory",
}
